import React from 'react';
import { Tooltip as MaterialTooltip } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
    fontSize: 12
  }
}));

const Tooltip = ({ ...props }) => {
  const classes = useStyles();

  return <MaterialTooltip arrow classes={classes} {...props} />;
};

export default Tooltip;
